import { BaseHttpService } from './base-http.service'

export default new (class AuthService extends BaseHttpService {
    getListDeliveries(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }

    createDelivery(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }

    getListMasterDelivery(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }

    approveUserDelivery(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }

    rejectDelivery(path: string, params: any): Promise<any> {
        return super.postPromise(path, params)
    }

    getMasterDeliveryDetail(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
    getDeliveryDetail(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
    getProductsDelivery(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }

})()